import React from "react"

const TitleText = () => {
  return (
    <h2 className="sparkle--title sparkle-deep-blue mb-lg-5 mb-3 text-center">
      What do you want to do today?
    </h2>
  )
}
export default TitleText
